import React, { createContext, useContext, ReactNode, PropsWithChildren } from 'react';
import { IRepositories } from '../types';

const RepositoryContext = createContext<IRepositories | null>(null);

interface RepositoryProviderProps {
  repositories: IRepositories;
}

export const RepositoryProvider: React.FC<PropsWithChildren<RepositoryProviderProps>> = ({ 
  children, 
  repositories 
}) => (
  <RepositoryContext.Provider value={repositories}>
    {children}
  </RepositoryContext.Provider>
);

export const useRepositories = () => {
  const context = useContext(RepositoryContext);
  if (!context) {
    throw new Error('useRepositories must be used within RepositoryProvider');
  }
  return context;
};